import React from 'react';
import ArrowBack from '@material-ui/icons/ArrowBack';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment/moment';
import styled from 'styled-components';
import CriteriaImage from 'CriteriaImage';

const TicketName = styled.span`
  // padding-left: 8px;
  font-weight: normal;
`;

const TitleHeader = styled.div`
  padding-left: 5.9375rem !important;
  padding-right: 5.9375rem !important;
  max-width: 1024px !important;
  margin: unset !important;
`;
const ActiveImage = styled.div`
  margin-left: 0rem !important;
`;

class SubHeaderTicketDetail extends React.Component {
  state = {
    current: moment(),
  };
  interval;
  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ current: moment() }),
      60000
    );
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  convertMS = milliseconds => {
    var day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    return {
      day,
      hour,
      minute,
      seconds,
    };
  };
  renderExpiringScale = () => {
    let { ticket } = this.props;
    if (ticket && ticket.validUntil) {
      let start = ticket.creatorInfo.dateCreated;
      let end = ticket.validUntil;
      const stillUtcStart = moment.utc(start).toDate();
      const stillUtcEnd = moment.utc(end).toDate();
      start = moment(stillUtcStart).local();
      end = moment(stillUtcEnd).local();

      const current = this.state.current;
      const diff = end.diff(current);
      const remained = this.convertMS(diff);
      const scale =
        100 * (current.diff(start, 'days') / end.diff(start, 'days'));
      return (
        <div>
          {remained.day >= 0 && (
            <p className="t-secondary-12 u-mrg-bot-5 expiring-date">
              {`${remained.day}d ${remained.hour}h ${remained.minute}m `}
            </p>
          )}
          {remained.day < 0 && (
            <span className="t-secondary-12 c-red t-weight-b">Expired</span>
          )}
          <LinearProgress
            classes={{
              barColorPrimary:
                scale < 80 ? 'progres_bg_primary' : 'progres_bg_secondary',
            }}
            variant="determinate"
            value={
              100 * (current.diff(start, 'days') / end.diff(start, 'days'))
            }
          />
        </div>
      );
    } else {
      return false;
    }
  };

  render() {
    return (
      // slips header
      <TitleHeader className="sub-header -slips -transparent">
        <div className="active-ticket-information ">
          {/* <div className="arrow-back">
            <ArrowBack onClick={this.props.goBack} />
          </div> */}
          <CriteriaImage
            mountingPosition={
              this.props.ticket ? this.props.ticket.mountingPosition : false
            }
            mountingType={
              this.props.ticket ? this.props.ticket.mountingType : false
            }
          />
          <div className="sub-header-content u-mrg-left-10">
            <p className="t-primary-24 u-mrg-bot-10 c-gray-light">
              <b>{this.props.ticket ? this.props.ticket.referenceName : ''}</b>
            </p>
            <h2 className="t-primary-24">
              <TicketName>
                {this.props.ticket ? this.props.ticket.name : ''}
              </TicketName>
            </h2>
            {/*<p className="t-secondary-14 u-mrg-bot-10">Ceiling, Downlight, Parabolic</p>*/}
          </div>
        </div>
        <div className="active-ticket-expiring pad-r-10 c-black">
          <p className="t-secondary-14 u-mrg-bot-15 t-a-l">
            <b>
              {this.props.ticket && this.props.ticket.ticketState !== 'DRAFT'
                ? 'Issued by: '
                : 'Drafted by: '}
            </b>
            {this.props.ticket ? this.props.ticket.creatorInfo.createdBy : ''},
            on{' '}
            {this.props.ticket
              ? moment(this.props.ticket.creatorInfo.dateCreated).format(
                  'MMM Do YYYY'
                )
              : ''}
          </p>

          {this.props.ticket && this.props.ticket.ticketState !== 'DRAFT'
            ? this.renderExpiringScale()
            : null}
        </div>
      </TitleHeader>
    );
  }
}

export default SubHeaderTicketDetail;
